
export function setOrDeleteSearchParams(params: URLSearchParams, key: any, value: any) {
  if (!value && params.get(key)) {
    params.delete(key)
  } else if (value) {
    params.set(key, value)
  }

  return params;
}